/**
 * Platform specific reload, handles reloading the javascript layer
 */
export const platformReload = (isNative: boolean) => {
  // For mobile apps, navigate to root first to avoid Android webview trying to load
  // non-existent asset files when reloading from client-side routes
  if (isNative) {
    // Use replaceState to change URL to root without triggering navigation
    window.history.replaceState({}, '', '/');
    // Small delay to ensure URL change is processed before reload
    setTimeout(() => window.location.reload(), 50);
  } else {
    window.location.reload();
  }
};
